module.exports = __webpack_public_path__ + "assets/views/00_common/dosing_icon_3weeks.png";